import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a6d1dc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-base-info" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "img-box" }
const _hoisted_5 = ["src"]

import { ref, watch } from 'vue'
import Text from '@/components/text'
import { get, isEmpty } from 'lodash'
import moment from 'moment'
import { formatLat, formatLng } from '@/utils/map.utils'
import defaultImg from '@/assets/img/device/device-default.png'
import { DEVICE_STATUS_ENUM, PRODUCT_TYPE } from '@/common'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-info',
  props: ['data'],
  setup(__props) {

const props = __props;

const t = i18n.global.t

const deviceStatusMap = {
  [DEVICE_STATUS_ENUM.INACTIVATE]: '',
  [DEVICE_STATUS_ENUM.ONLINE]: 'success',
  [DEVICE_STATUS_ENUM.OFFLINE]: 'info',
  [DEVICE_STATUS_ENUM.NOACTIVATE]: 'warning',
}



watch(
  () => props.data,
  () => {
    if (!isEmpty(props.data)) {
      dealwidthData(props.data)
    }
  },
  {
    deep: true,
    immediate: true,
  }
)

const productImg = ref(defaultImg)
const deviceInfo: any = ref({})
const dealwidthData = (resData?: any) => {
  const data = resData || {}
  deviceInfo.value = data
  baseInfo.value = baseInfo.value
    .map((item: any) => {
      if (item.filter && !item.filter(data)) {
        return false
      }
      if (item.formatter) {
        return {
          ...item,
          value: item.formatter(data),
        }
      } else {
        return {
          ...item,
          value: data[item.key],
        }
      }
    })
    .filter(Boolean)
  const { productImage, productImageBaseUrl } = data
  if (productImage) {
    productImg.value = productImageBaseUrl + productImage
  }
}

const baseInfo = ref([
  {
    title: '',
    value: '',
    key: 'deviceName',
    class: 'device-name ws_mb10',
    span: 24,
  },
  {
    title: t('D_INFO.colOrg') + ' : ',
    value: '',
    key: 'topOrgName',
  },
  {
    title: 'SN : ',
    value: '',
    key: 'deviceSn',
  },
  {
    title: t('D_INFO.colProduct') + ' : ',
    value: '',
    key: 'productTypeValue',
  },
  {
    title: t('D_INFO.deviceLabel') + ' : ',
    value: '',
    key: 'deviceLabel',
    filter: (data: any) => {
      return !!data.deviceLabel
    },
  },
  {
    title: t('D_INFO.accessMethod') + ' : ',
    value: '',
    key: 'connectType',
  },
  {
    title: t('D_INFO.colAddress') + ' : ',
    value: '',
    key: '',
    formatter: (data: any) => {
      return get(data, 'deviceLocationInfo.deviceAddress')
    },
  },

  {
    title: t('D_INFO.latLng') + ' : ',
    value: '',
    key: 'deviceAddress',
    formatter: (data: any) => {
      if (data?.deviceLocationInfo) {
        const { latitude, longitude } = data?.deviceLocationInfo
        return (
          formatLat(latitude) +
          ' ' +
          latitude +
          '°' +
          ' ' +
          formatLng(longitude) +
          ' ' +
          longitude +
          '°'
        )
      }
      return '-'
    },
  },
  {
    title: t('D_INFO.belogingSite') + ' : ',
    value: '',
    key: 'siteName',
  },
  {
    title: '电池电压 : ',
    value: '',
    key: 'batteryVoltage',
    formatter: ({ batteryVoltage, batteryVoltageUnit }: any) => {
      return batteryVoltage ? batteryVoltage + ' ' + batteryVoltageUnit : '-'
    },
    filter: ({ sgFlag,productTypeCode }: any) => {
      return !sgFlag && PRODUCT_TYPE.DIRECT_CONNECT !== productTypeCode
    },
  },
  {
    title: '外部供电 : ',
    value: '',
    key: 'outerBatVol',
    formatter: ({ batteryVoltage, batteryVoltageUnit }: any) => {
      const num = Number(batteryVoltage)
      if (num < 4) {
        return '无外部供电'
      }
      return batteryVoltage + ' ' + batteryVoltageUnit
    },
    filter: ({ sgFlag }: any) => {
      return sgFlag
    },
  },
  {
    title: t('D_INFO.colCreateTime') + ' : ',
    value: '',
    key: 'createDate',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
])

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('D_DATA.baseInfo')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_unref(isEmpty)(deviceInfo.value))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: productImg.value,
              alt: ""
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "base-info"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseInfo.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              span: item.span || 12,
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Text), {
                  content: item.value,
                  class: _normalizeClass(item.class)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title) + _toDisplayString(item.value || '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["content", "class"])
              ]),
              _: 2
            }, 1032, ["span"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["status", deviceStatusMap[deviceInfo.value.deviceStatusCode]])
    }, _toDisplayString(_ctx.$t('D_DATA.status')) + "：" + _toDisplayString(deviceInfo.value.deviceStatusName), 3)
  ]))
}
}

})